import { render, staticRenderFns } from "./merchantBusiness.vue?vue&type=template&id=0edcc765&scoped=true&"
import script from "./merchantBusiness.vue?vue&type=script&lang=js&"
export * from "./merchantBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edcc765",
  null
  
)

export default component.exports